export default "__VITE_ASSET__BWWyfr71__"